// rh-dialog/rh-dialog.js
import { createComponent } from '@lit/react';
import react from 'react';
import { RhDialog } from '@rhds/elements/rh-dialog/rh-dialog.js';
export const Dialog = createComponent({
  tagName: 'rh-dialog',
  elementClass: RhDialog,
  react,
  events: {
    onOpen: 'open',
    onClose: 'close',
    onCancel: 'cancel',
  },
});
